<template>
  <div class="overview"
       :class="overviewClasses">
    <header-mobile-page v-if="$mq === 'mobile'"
                        label="Family Overview" />
    <children-map v-if="childrenWithLocation.length > 0"
                  :children="childrenWithLocation"
                  class="map"
                  mode="overview" />
    <map-empty-screen v-if="childrenWithLocation.length === 0" />
    <child-settings-panels />
    <router-link v-if="$mq === 'mobile'"
                 class="overview-feed-link"
                 :to="{ name: 'feed' }">
      <base-fab icon="icon-feed"
                iconColor="#fff" />
    </router-link>
  </div>
</template>

<script>
  import ChildrenMap from '@/components/Map/Map.vue'
  import ChildSettingsPanels from '@/components/Child/ChildSettingsPanels/ChildSettingsPanels.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'
  import MapEmptyScreen from '@/components/Map/MapEmptyScreen.vue'

  import analytics from '@/services/analytics.js'

  export default {
    components: {
      ChildrenMap,
      ChildSettingsPanels,
      HeaderMobilePage,
      MapEmptyScreen
    },

    created() {
      analytics.sendEvent('Overview_Sc')
      analytics.sendEvent('Feed_Sc')
    },

    computed: {
      childrenWithLocation() {
        return this.children.filter(child => {
          return _.has(child, 'latest_location') && child.latest_location
        })
      },

      ...mapGetters('children', {
        children: 'get'
      }),

      overviewClasses() {
        return {
          'overview-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .overview {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .overview-mobile {
    .map {
      height: 50%;
    }
  }
</style>
